import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

type Transferencia = {
  id: number;
  titulo: string | null;
  jogador_nome: string;
  posicao: string | null;
  clube_origem: string | null;
  clube_origem_escudo: string | null;
  clube_destino: string | null;
  clube_destino_escudo: string | null;
  status: string;
  cor_status: string | null;
  ativo: boolean | null;
  ordem: number | null;
};

// AJUSTE AQUI AS DIMENSOES DA BARRA DE NOTICIAS:
// - tickerContainerClassName: altura minima, bordas e dimensoes da barra preta.
// - mercadoLabelClassName: largura, altura e espacamento do detalhe vermelho "MERCADO".
// Exemplos uteis:
// - aumente min-h-[58px] para min-h-[70px] se quiser a barra preta mais alta.
// - aumente min-w-[128px] para min-w-[160px] se quiser o bloco vermelho mais largo.
// - aumente px-5/py-4 para deixar o bloco vermelho com mais respiro interno.
const tickerContainerClassName =
  "fixed left-0 right-0 top-16 md:top-20 z-40 bg-alvinegro-black text-white border-t border-white/10 border-b border-white/10 overflow-hidden";

const mercadoLabelClassName =
  "shrink-0 self-stretch bg-red-600 px-4 md:px-6 text-[11px] md:text-xs font-bold uppercase tracking-wider flex items-center gap-2";

export default function MercadoTicker() {
  const [items, setItems] = useState<Transferencia[]>([]);

  useEffect(() => {
    async function carregar() {
      const { data } = await supabase
        .from("mercado_transferencias")
        .select(
          "id,titulo,jogador_nome,posicao,clube_origem,clube_origem_escudo,clube_destino,clube_destino_escudo,status,cor_status,ativo,ordem",
        )
        .eq("ativo", true)
        .order("ordem", { ascending: true })
        .order("criado_em", { ascending: false });

      setItems((data || []) as Transferencia[]);
    }

    carregar();
  }, []);

  if (items.length === 0) return null;

  const duplicatedItems = [...items, ...items];

  return (
    <>
      <div className={tickerContainerClassName}>
        <div className="flex h-10 items-center">
          <div className={mercadoLabelClassName}>
            <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
            <span>Mercado</span>
          </div>

          <div className="relative overflow-hidden flex-1">
            <div className="mercado-ticker-track flex items-center gap-8 whitespace-nowrap">
              {duplicatedItems.map((item, index) => (
                <div
                  key={`${item.id}-${index}`}
                  className="inline-flex items-center gap-3 text-xs md:text-sm"
                >
                  {item.clube_origem_escudo && (
                    <img
                      src={item.clube_origem_escudo}
                      alt={item.clube_origem || ""}
                      className="w-6 h-6 rounded-full bg-white object-contain p-0.5"
                    />
                  )}

                  <span className="font-semibold">{item.jogador_nome}</span>

                  {item.posicao && (
                    <span className="text-white/50">({item.posicao})</span>
                  )}

                  <span className="text-white/40">
                    {item.clube_origem || "Livre"}
                  </span>

                  <i className="ri-arrow-right-line text-white/50" />

                  <span className="text-white/40">
                    {item.clube_destino || "Destino indefinido"}
                  </span>

                  {item.clube_destino_escudo && (
                    <img
                      src={item.clube_destino_escudo}
                      alt={item.clube_destino || ""}
                      className="w-6 h-6 rounded-full bg-white object-contain p-0.5"
                    />
                  )}

                  <span
                    className="mr-4 px-3 py-1.5 rounded-full text-[11px] font-bold text-white"
                    style={{ backgroundColor: item.cor_status || "#3b82f6" }}
                  >
                    {item.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <style>{`
        .mercado-ticker-track {
          width: max-content;
          animation: mercadoTicker 35s linear infinite;
        }

        .mercado-ticker-track:hover {
          animation-play-state: paused;
        }

        @keyframes mercadoTicker {
          0% {
            transform: translateX(0);
          }

          100% {
            transform: translateX(-50%);
          }
        }
        `}</style>
      </div>

      <div className="h-10" aria-hidden="true" />
    </>
  );
}
